/**
 * The per-document pages on airisk.mit.edu (/governance-documents/<slug>),
 * shared by the Webflow sync (which creates the items) and the governance
 * views (which link to them). Browser-safe: no Node imports, so the embed can
 * use it.
 *
 * As for incidents (lib/incidentPages), the slug is computed from the id and
 * official name with the function the sync used when it CREATED the item, so
 * the views need no lookup; an item keeps its slug for life, so
 * `documentPageUrl` only matches an item whose name has not changed since.
 */
import { SITE_ORIGIN, slugFrom } from './sitePages';

export const DOCUMENT_COLLECTION_PATH = '/governance-documents';
export const DOCUMENT_VIEW_URL = `${SITE_ORIGIN}/governance/document-view`;

/**
 * Whether the pages are on production (template live 27 Oct 2026, every
 * document published the same day). While false the views show no links to
 * the pages, so nothing points at a 404.
 */
export const DOCUMENT_PAGES_LIVE = true;

/** `<id>-<name words>`, at most 60 characters, never ending on a stopword. */
export function documentSlugFor(id: string, name: string): string {
  return slugFrom(id, name);
}

export function documentPageUrlForSlug(slug: string): string {
  return `${SITE_ORIGIN}${DOCUMENT_COLLECTION_PATH}/${slug}`;
}

/** The page for a document, or '' when the pages are not live. */
export function documentPageUrl(id: string, name: string, live = DOCUMENT_PAGES_LIVE): string {
  if (!live || !/^\d+$/.test(id)) return '';
  return documentPageUrlForSlug(documentSlugFor(id, name));
}
